import { render, staticRenderFns } from "./SearchInterface.vue?vue&type=template&id=50cd5c52&scoped=true&"
import script from "./SearchInterface.vue?vue&type=script&lang=js&"
export * from "./SearchInterface.vue?vue&type=script&lang=js&"
import style0 from "./SearchInterface.vue?vue&type=style&index=0&id=50cd5c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd5c52",
  null
  
)

export default component.exports